import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;

export const getAllProductReview = async () => {
  const response = await axios.get(
    `${baseUrl}/api/ColtecProduct/GetAllProductReview`
  );
  return response.data;
};
